import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AddressTile from "../helpers/AddressTile";
import AddressForm from "./AddressForm";
import {
  fetchUserAddresses,
  addUserAddress,
  editUserAddress,
  makeDefaultAddress,
  deleteUserAddress,
} from "../../slices/address";
import { SimpleGrid } from "@chakra-ui/react";
import useDeviceType from "../helpers/GetDevice";

export default function Addresses() {
  const [addNewAddress, setAddNewAddress] = useState(false);
  const [editAddress, setEditAddress] = useState(null);
  const dispatch = useDispatch();
  const deviceType = useDeviceType();

const { addresses = [], status, error } = useSelector((state) => state.userAddress);

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchUserAddresses());
    }
  }, [status, dispatch]);

  const handleEdit = (address) => {
    setEditAddress(address);
    console.log(address);
    setAddNewAddress(true);
  };

  const handleMakeDefault = (id) => {
    dispatch(makeDefaultAddress(id));
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this address?")) {
      dispatch(deleteUserAddress(id));
    }
  };

  const handleFormSubmit = (formData) => {
    if (editAddress) {
      dispatch(editUserAddress({ id: editAddress.id, address: formData }));
      setEditAddress(null);
    } else {
      dispatch(addUserAddress(formData));
    }
    setAddNewAddress(false);
  };

if (status === "loading") {
  return (
    <div className="d-flex justify-content-center align-items-center py-5 ">
      <div className="spinner-border me-2" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
      <p className="m-0">Loading addresses...</p>
    </div>
  );
}  

if (status === "failed") {
  return (
    <div className="alert alert-danger d-flex align-items-center" role="alert">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-exclamation-triangle-fill flex-shrink-0 me-2" viewBox="0 0 16 16">
        <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.43.954.953v7.093c0 .523-.42.954-.954.954-.535 0-.954-.43-.954-.954V5.953c0-.523.42-.953.954-.953z"/>
      </svg>
      <div>
        <h4 className="alert-heading mb-1">Error Loading Data</h4>
        Error: **{error || "An unknown error occurred."}**
      </div>
    </div>
  );
}

  if (addNewAddress) {
    return (
      <AddressForm
        onClose={() => {
          setAddNewAddress(false);
          setEditAddress(null);
        }}
        initialData={editAddress}
        onSubmit={handleFormSubmit}
        cssClass="address-new-container"
      />
    );
  }

  return (
 
      <SimpleGrid
                columns={{ base: 1, sm: 2, md: 2, lg: 3, xl: 3 }}
                spacing={{ base: 3, md: 5 }}
                p={{ base: 3, md: 10 }}
                gap={4}

              >
      {addresses.map((address) => (
        <AddressTile
          key={address.id}
          name={address.name}
          phone={address.phone}
          address1={address.address_line1}
          address2={address.address_line2}
          city={address.city}
          state={address.state}
          pin={address.postal_code}
          onEdit={() => handleEdit(address)}
          onMakeDefault={() => handleMakeDefault(address.id)}
          onDelete={() => handleDelete(address.id)}
          isDefault={address.is_default}
          id = {address.id}
          email = {address.email}
        />
      ))}
       <AddressTile
        isNew={true}
        onAddNewAddress={() => setAddNewAddress(true)}
      />
      </SimpleGrid>

     
  
  );
}
